import topAvailableQuantitySummary from './top-available-quantity-summary';
import { ActionModal } from '@vpp-frontend-components/action-modal';

export default topAvailableQuantitySummary(ActionModal);
